import Vueset from "~/utils/Vueset";

export const state = () => ({
  loading: false,
  items: [],
  links: {
    first: '',
    last: '',
    next: '',
    prev: ''
  },
  pagination: {
    current_page: 1,
    from: 0,
    last_page: 0,
    per_page: 0,
    nextPage: '',
    prevPage: '',
    to: 0,
    total: 0
  },
  openSidebar: false,
  timezones: [],
  languages: [],
  transcriptionLanguages: [],
  incentives: [],
  messagingNumbers: null,
  roles: [],
  mapToFields: []
});

export const getters = {
  items: state => state.items,
  links: state => state.links,
  pagination: state => state.pagination,
  timezones: state => state.timezones,
  languages: state => state.languages,
  transcriptionLanguages: state => state.transcriptionLanguages,
  incentives: state => state.incentives,
  messagingNumbers: state => state.messagingNumbers,
  roles: state => state.roles,
  mapToFields: state => state.mapToFields,
  userCan: (state, getters, rootState) => (permission, type = null) => {
    const rootStateTest = rootState.auth.user.permissions && rootState.auth.user.permissions.includes(permission);
    const typeTest = type && type.permissions && type.permissions.includes(permission);

    if(type !== null){
      return typeTest;
    }

    return (rootStateTest);
  }
};

export const mutations = {
  IS_LOADING(state, loading) {
    state.loading = loading;
  },

  SET_ALL(state, items) {
    state.items = items.data;
    state.links = items.links;
    state.pagination = items.meta;
  },

  SET_ITEMS(state, items) {
    state.items = items;
  },

  SET_LINKS(state, links) {
    state.links = links;
  },

  SET_PAGINATION(state, pagination) {
    state.pagination = pagination;
  },

  UPDATE_ITEM(state, payload) {
    state.items.splice(payload.index, 1, payload.data);
  },

  DELETE_ITEM(state, index) {
    state.items.splice(index, 1);
  },

  RESET_RESULTS(state) {
    state.items = [];
    state.links = {};
    state.pagination = {};
  },

  TOGGLE_SIDEBAR(state) {
    state.openSidebar = !state.openSidebar;
  },

  SET_GLOBAL_VALUES(state, payload) {
    state.incentives = payload.incentives;
    state.languages = payload.languages;
    state.transcriptionLanguages = payload.transcriptionLanguages;
    state.timezones = payload.timezones;
    state.messagingNumbers = payload.messagingNumbers,
    state.mapToFields = payload.mapToFields;
  },

  SET_INCENTIVES(state, incentives) {
    state.incentives = incentives;
  },

  SET_LANGUAGES(state, languages) {
    state.languages = languages;
  },

  SET_TIMEZONES(state, timezones) {
    state.timezones = timezones;
  },

  SET_ROLES(state, roles) {
    state.roles = roles;
  },

  UPDATE_ITEM_BY_UUID(state, data){
    Vueset(state.items, data.index, data.data);
  }
};
